module.exports = __webpack_public_path__ + "static/img/index-poetry.bfddfa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/index-poetry.png
// module id = Zqab
// module chunks = 1